var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BlackFlatTooltip, DesignersTooltipItem } from './styles';
import { Avatar, Tooltip, FInter, FlexBox } from '@brg/ui';
// import { TooltipProps } from '@brg/ui/dist/ui-tooltip/Tooltip'
import React from 'react';
import styled from "styled-components";
import { Endpoints } from "@brg/api";
var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  &:active {\n    text-decoration: none;\n  }\n"], ["\n  text-decoration: none;\n  &:active {\n    text-decoration: none;\n  }\n"])));
export var ProjectDesignersTooltip = function (props) {
    var items = props.items, containerRef = props.containerRef;
    return (React.createElement(Tooltip, __assign({}, props),
        React.createElement(BlackFlatTooltip, { ref: containerRef, hidden: items.length === 0 },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', width: '100%', wrapMobile: 'wrap', onClick: function (ev) { return ev.stopPropagation(); } }, items.map(function (value) {
                var _a, _b, _c, _d;
                var isBigFullname = ((_a = value === null || value === void 0 ? void 0 : value.name) === null || _a === void 0 ? void 0 : _a.length) + ((_b = value === null || value === void 0 ? void 0 : value.surName) === null || _b === void 0 ? void 0 : _b.length) > 20;
                return (React.createElement(Link, { key: value === null || value === void 0 ? void 0 : value.identifier, href: '/designer/' + (value === null || value === void 0 ? void 0 : value.designerId) },
                    React.createElement(DesignersTooltipItem, { className: 'item' },
                        React.createElement(FlexBox, { height: '100%', align: 'center', width: '100%' },
                            React.createElement(FlexBox, { width: 32, height: 32, style: { borderRadius: '3px' } },
                                React.createElement(Avatar, { avatar: Endpoints.files + '/' + (((_c = value === null || value === void 0 ? void 0 : value.avatar) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (_d = value === null || value === void 0 ? void 0 : value.avatar[0]) === null || _d === void 0 ? void 0 : _d.url : undefined), fs: 11 })),
                            React.createElement(FInter.SmallTextFlex, { offsetLeft: 12, offsetRight: 16, style: {
                                    fontSize: isBigFullname ? '11px' : '13px',
                                    lineHeight: '16px'
                                } }, value === null || value === void 0 ? void 0 :
                                value.name,
                                " ", value === null || value === void 0 ? void 0 :
                                value.surName)))));
            })))));
};
var templateObject_1;
//# sourceMappingURL=ProjectDesignersTooltip.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BlackFlatTooltip, DesignersTooltipItem } from './styles';
import { Avatar, Tooltip, FInter, FlexBox } from '@brg/ui';
// import { TooltipProps } from '@brg/ui/dist/ui-tooltip/Tooltip'
import React from 'react';
import styled from "styled-components";
import { Endpoints } from "@brg/api";
var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  &:active {\n    text-decoration: none;\n  }\n"], ["\n  text-decoration: none;\n  &:active {\n    text-decoration: none;\n  }\n"])));
export var ProjectDesignersTooltip = function (props) {
    var items = props.items, containerRef = props.containerRef;
    return (React.createElement(Tooltip, __assign({}, props),
        React.createElement(BlackFlatTooltip, { ref: containerRef, hidden: items.length === 0 },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', width: '100%', wrapMobile: 'wrap', onClick: function (ev) { return ev.stopPropagation(); } }, items.map(function (value) {
                var _a, _b, _c, _d;
                var isBigFullname = ((_a = value === null || value === void 0 ? void 0 : value.name) === null || _a === void 0 ? void 0 : _a.length) + ((_b = value === null || value === void 0 ? void 0 : value.surName) === null || _b === void 0 ? void 0 : _b.length) > 20;
                return (React.createElement(Link, { key: value === null || value === void 0 ? void 0 : value.identifier, href: '/designer/' + (value === null || value === void 0 ? void 0 : value.designerId) },
                    React.createElement(DesignersTooltipItem, { className: 'item' },
                        React.createElement(FlexBox, { height: '100%', align: 'center', width: '100%' },
                            React.createElement(FlexBox, { width: 32, height: 32, style: { borderRadius: '3px' } },
                                React.createElement(Avatar, { avatar: Endpoints.files + '/' + (((_c = value === null || value === void 0 ? void 0 : value.avatar) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (_d = value === null || value === void 0 ? void 0 : value.avatar[0]) === null || _d === void 0 ? void 0 : _d.url : undefined), fs: 11 })),
                            React.createElement(FInter.SmallTextFlex, { offsetLeft: 12, offsetRight: 16, style: {
                                    fontSize: isBigFullname ? '11px' : '13px',
                                    lineHeight: '16px'
                                } }, value === null || value === void 0 ? void 0 :
                                value.name,
                                " ", value === null || value === void 0 ? void 0 :
                                value.surName)))));
            })))));
};
var templateObject_1;
//# sourceMappingURL=ProjectDesignersTooltip.js.map